module.exports = __webpack_public_path__ + "img/undraw_authentication_fsn5.a1caf7b5.svg";